module.exports = __webpack_public_path__ + "static/media/empty-finvaro.03de3124.svg";